import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiNameDescriptionInputComponent } from './name-description-input.component';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiSimpleContenteditableModule } from '@fi-shared/fi-simple-contenteditable/fi-simple-contenteditable.module';
import { FiNameDescriptionEditorDialogComponent } from './name-description-editor-dialog/name-description-editor-dialog.component';
import { InfoIconModule } from '../info-icon/info-icon.module';
import { MatIconModule } from '@angular/material/icon';
import { FiNameInputModule } from '@fi-app/shared/fi-name-input/fi-name-input.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        FiAppTextSharedModule,
        FiSimpleContenteditableModule,
        InfoIconModule,
        MatIconModule,
        FiNameInputModule,
    ],
    declarations: [FiNameDescriptionInputComponent, FiNameDescriptionEditorDialogComponent],
    exports: [FiNameDescriptionInputComponent, FiNameDescriptionEditorDialogComponent],
})
export class FiNameDescriptionInputModule {}
